import { PlatformEnum, URLEnums, urls } from "src/utils/environmentStore";

export const environment = {
  production: true,
  aosURL: urls(URLEnums.AOS_Front_COM),
  aosBackEndURL: urls(URLEnums.AOS_Back_COM),
  platForm: PlatformEnum.US,
  partnerUser: 'aosplatform@amadeosystems.com'
};


// aosURL: 'https://aos-cloud.myamadeo.net',
//   aosBackEndURL: 'https://aos-api.myamadeo.net',
//   partnerUser: 'aosplatform@amadeosystems.com'

// aosURL: 'https://aos-cloud.myamadeo.eu',
//   aosBackEndURL: 'https://www.skyaccess.eu/IntegraAdminAPI',
//   partnerUser: 'aosplatform@amadeosystems.com'

// aosURL: 'https://aos-cloud.myamadeo.com',
//   aosBackEndURL: 'https://www.skyaccess.us/IntegraAdminAPI',
//   partnerUser: 'aosplatform@amadeosystems.com'




